module.exports = __webpack_public_path__ + "static/media/checkbox-focussed.66b59f95.svg";